<template>
  <transition name="share-popup">
    <div class="popup-back">
      <section class="popup pop-common-share">
        <h1 class="popup-title" tabindex="1">컨텐츠 공유 팝업</h1>
        <div class="popup-button-close">
          <button @click="$emit('on-click-close')">
            <img
              :src="require('@/assets/images/common/btn-popup-close.svg')"
              alt="팝업 닫기"
            >
          </button>
        </div>

        <h2 tabindex="0">공유</h2>

        <ul class="sns-share">
          <li
            v-for="sns in snsList"
            :key="sns.title"
          >
            <a @click.prevent="sns.onClick" href="javascript:void(0)">
              <div class="sns-img">
                <img :src="sns.image" :alt="sns.title">
              </div>
              <strong>{{ sns.title }}</strong>
            </a>
          </li>
        </ul>

        <ul class="share-link">
          <li>
            <input id="page-link" type="text" v-model="url">
          </li>
          <li>
            <button @click.prevent="clickCopyLink()">링크복사</button>
          </li>
        </ul>
      </section>
    </div>
  </transition>
</template>

<script>
import constant from '@/common/resources/constant'
  import {
    URL_WAVVE,
    URL_WAVVE_DEV,
    URL_WAVVE_QA,
    URL_WAVVE_STG
  } from '@/common/resources/const'

  export default {
    props: {
      title: {
        type: String
      },
      description: {
        type: String
      },
      id: {
        type: String,
        default: ''
      }
    },
    data () {
      return {
        snsList: [
          {
            title: 'X (트위터)',
            image: require('@/assets/images/common/ico-share-twitter.png'),
            onClick: this.clickTwitter
          },
          {
            title: '페이스북',
            image: require('@/assets/images/common/ico-share-facebook.png'),
            onClick: this.clickFacebook
          }
        ],
        url: `${window.location.protocol}//${this.checkURL(window.location.host)}`
      }
    },
    methods: {
      checkURL (location = '') {
        const validPathList = [
          URL_WAVVE,
          URL_WAVVE_DEV,
          URL_WAVVE_QA,
          URL_WAVVE_STG
        ]

        // live 채널일 경우
        if (this.id.match(/live_channel/gi)) {
          return this.urlOrigin(location)
        }

        return !validPathList.includes(location)
          ? this.urlOrigin(location)
          : this.urConverted(location)
      },
      urlOrigin (location = '') {
        return `${location}${window.location.pathname}${window.location.search}`
      },
      urConverted (location = '') {
        const ORIGIN = /(?:qa-|dev-|stg-)?www\.(wavve)/gi
        const DEEP = 'deep.wavve'
        return `${location.replace(ORIGIN, DEEP)}/content/${this.id}`
      },
    clickFacebook () {
      /* eslint-disable */
      FB.ui({
    		method: 'share',
        href: this.url
    	},
    	function (response) {
        if (response && !response.error_message) {
          // then get post content
        } else {
        }
    	});

      return false;
    },
    clickTwitter() {
      const popup = window.open(
        `https://twitter.com/share?text=[wavve] ${encodeURIComponent(this.title)}%0a${encodeURIComponent(this.description)}%0a&url=${encodeURIComponent(this.url)}`,
        `트위터 공유`,
        `width=626,height=436`
      )
      popup.window.focus();
    },
    clickCopyLink() {
      const element = document.getElementById('page-link');
      element.select();
      document.execCommand('Copy');
      this.$events.$emit('OPEN_PPV_TOAST', () => {}, constant.MSG_SHARE_COMPLETE_COPY_LINK)
    }
  },
  beforeCreate () {
    window.fbAsyncInit = function() {
      FB.init({
        appId            : '1818575348440201',
        autoLogAppEvents : true,
        version          : 'v4.0'
      });
    };

    (function(d, s, id){
      var js, fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) {return;}
      js = d.createElement(s); js.id = id;
      js.src = "https://connect.facebook.net/ko_KR/sdk.js";
      fjs.parentNode.insertBefore(js, fjs);
    }(document, 'script', 'facebook-jssdk'));
  },
  created () {
    this.checkURL()
  },
}
</script>
